import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Route guard for privileged surfaces (admin + attorney).
 * - If MFA is required but not enrolled -> redirect to /mfa/setup
 * - If enrolled but not verified this session -> redirect to /mfa/verify?return_to=X
 * - Otherwise render children as-is
 */
export default function RequireMfa({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  const status = user?.mfa_status;
  if (!status || !status.required) return children;
  if (!status.enrolled) {
    return <Navigate to="/mfa/setup" replace state={{ from: loc.pathname }} />;
  }
  if (!status.verified) {
    return (
      <Navigate
        to={`/mfa/verify?return_to=${encodeURIComponent(loc.pathname)}`}
        replace
      />
    );
  }
  return children;
}
